/* global $ */

export default function scrollToElement(element, time = 800) {
  let anchorElement = null;
  if (element instanceof HTMLElement) anchorElement = element;
  if (typeof element === "string")
    anchorElement = document.querySelector(element);

  if (anchorElement) {
    $("html, body").animate(
      {
        scrollTop: $(anchorElement).offset().top
      },
      time
    );
  }
}
